import React from 'react'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="gwjk_epTyaY"
                    title="IN-8015 FHD Unboxing"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="IN-8015 FHD Unboxing"
              footer={
                <EuiText>
                  <p>Die ganz neue INSTAR IN-8015 Full HD. Das Flagschiff unter den IP Innenkameras. Dank eines Panasonic WDR Bildsensors erzeugt die IN-8015 sagenhafte Aufnahmen bei Tag als auch bei Nacht. Der eingebaute PIR Wärmesensor verhindert zudem das die Kamera Fehlalarme erzeugt und eine mitgelieferte 16GB MicroSD Speicherkarte ermöglicht das Aufnahmen der Alarm Videos von bis zu mehr als einem Monat. Wem das nicht reicht, der kann bis zu 128GB MicroSD Speicherkarten in die Kamera einsetzen. </p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
